<!-- HomeView.vue -->
<script setup lang="ts">
import { useI18n } from "vue-i18n";
import jaJP from "@/locales/ja-JP.json";
import enUS from "@/locales/en-US.json";
import WindowCard from "@/components/base/WindowCard.vue";
import TaskList from "@/components/TaskList.vue";

type MessageSchema = typeof jaJP;

const { t } = useI18n<{
  message: MessageSchema
}, "ja-JP" | "en-US">({
  inheritLocale: true,
  messages: {
    "ja-JP": jaJP,
    "en-US": enUS,
  }
});

</script>

<template>
  <div class="home-view">
    <WindowCard>
      <template #title>{{ t("tasks.title") }}</template>
      <template #contents>
        <TaskList />
      </template>
    </WindowCard>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/sass/mixin.scss";

</style>